class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.announcement-bar__item'));
    if (this.items.length < 2) return;
    this.index = 0;
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1, true));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1, true));
    const autoplay = Number(this.dataset.autoplay);
    if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.timer = setInterval(() => this.go(1), autoplay);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => (this.timer = setInterval(() => this.go(1), autoplay)));
    }
    document.addEventListener('shopify:block:select', (event) => {
      const target = this.items.findIndex((item) => item.contains(event.target));
      if (target > -1) this.show(target);
    });
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
  go(direction, manual = false) {
    if (manual) clearInterval(this.timer);
    this.show((this.index + direction + this.items.length) % this.items.length);
  }
  show(index) {
    this.items[this.index].hidden = true;
    this.index = index;
    const item = this.items[index];
    item.hidden = false;
    item.style.animation = 'none';
    void item.offsetWidth;
    item.style.animation = '';
  }
}
if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);
